module.exports = __webpack_public_path__ + "static/img/album_3.13d4801.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/album_3.png
// module id = 0fqG
// module chunks = 1